export default __webpack_public_path__ + "static/media/orange-circle-empty.fd89c3c0.svg";